module.exports = __webpack_public_path__ + "media/assets/logo/Logo_SemFundo_Agrosim_reduzido-8684298e05228c1a14c8638587d1d3b2.png";